var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.643,
    height: 21.307,
    viewBox: "0 0 18.643 21.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(-188.024 -277.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6961",
    "data-name": "Path 6961",
    d: "M203.171,280.462h-.5v-1.329a1.329,1.329,0,1,0-2.659,0v1.329h-5.33v-1.329a1.33,1.33,0,1,0-2.661,0v1.329h-.5a3.5,3.5,0,0,0-3.495,3.5v.5h18.643v-.5A3.5,3.5,0,0,0,203.171,280.462Zm-9.822,2.543a1.317,1.317,0,0,1-1.316-1.319,1.422,1.422,0,0,1,.022-.26,1.4,1.4,0,0,0,2.588,0,1.172,1.172,0,0,1,.026.26A1.32,1.32,0,0,1,193.349,283.005Zm8.015,0a1.317,1.317,0,0,1-1.317-1.319,1.812,1.812,0,0,1,.022-.26,1.4,1.4,0,0,0,2.588,0,1.422,1.422,0,0,1,.026.26A1.318,1.318,0,0,1,201.363,283.005Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6962",
    "data-name": "Path 6962",
    d: "M191.353,282.415h-3.329v9.824a3.491,3.491,0,0,0,3.491,3.495h11.655a3.492,3.492,0,0,0,3.5-3.495v-9.824H191.353ZM190.02,292.1v-7.8h14.648v7.8a1.754,1.754,0,0,1-1.748,1.754H191.77A1.756,1.756,0,0,1,190.02,292.1Z",
    transform: "translate(0 3.374)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.753f18bed629378a262d1761df69b3c6.svg";
export { ForwardRef as ReactComponent };